import type { IConfig } from './models';

export const configDesktop: IConfig = {
    mb: 48,
    pb: 24,
    pt: 48,
    textMb: 24,
    textMr: 32,
};
export const configMobile: IConfig = {
    mb: 32,
    pb: 32,
    pt: 32,
    textMb: 12,
    textMr: 0,
};
